import styled from 'styled-components';
import { FONTS, COLORS } from '@ertelecom/ui-react/assets/js/constants';

import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton';
import TitleSelect from '@ertelecom/ui-react/components/select/titleSelect';

import DetailPick from '~/static/images/icons/detail.svg';

export const TitleLink = styled.a`
    font-family: ${FONTS.medium};
    font-size: 16px;
    line-height: 1.25;
    color: ${COLORS.black};
`;

export const PriceBlock = styled.div`
    display: block;
    position: absolute;
    left: 24px;
    right: 24px;
    bottom: 24px;
`;

export const Price = styled.div`
    font-family: ${FONTS.medium};
    color: ${COLORS.black};
    font-size: 20px;
    line-height: 1;
    margin-top: 21px;
    display: block;
    
    @media(max-width: 768px) {
        font-size: 16px;
    }
`;

export const TextButton = styled.div`
    position: relative;
    margin-right: 120px;
`;

export const OldPrice = styled.span`
    left: 0;
    top: -18px;
    font-family: ${FONTS.regular};
    color: ${COLORS.darkGrey};
    font-size: 14px;
    line-height: 1;
    
    position: absolute;
    text-decoration: line-through;
`;

export const Leasing = styled.a`
    font-family: ${FONTS.regular};
    color: ${COLORS.darkGrey};
    font-size: 12px;
    line-height: 18px;
    display: inline-block;
    border-bottom: 1px ${COLORS.darkGrey} dashed;
    cursor: pointer;
    
    @media(max-width: 768px) {
        font-size: 10px;
    }
`;

export const Select = styled(TitleSelect)`
    display: inline-block;
    position: absolute;
    left: 0;
    top: 44px;
`;

export const Button = styled(StyledButton)`
    height: 48px;
    width: 117px;
    min-width: 117px;
    padding: 5px;
    position: absolute;
    right: 0;
    bottom: 0;
`;

export const Label = styled.div`
    border-radius: 11px;
    background: ${props => props.color} center no-repeat;
    color: ${COLORS.white};
    height: 22px;
    padding: 2px 8px;
    width: fit-content;
    margin-right: 4px;
    font-family: ${FONTS.regular};
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
`;

export const LabelWrapper = styled.div`
    flex-wrap: nowrap;
    display: flex;
    flex-direction: row;
    width: 80%;
`;

export const DetailBlock = styled.div`
    display: flex;
    flex-direction: column;
    width: 20%;
    align-items: flex-end;
`;

export const Detail = styled.div`
    width: 24px;
    height: 24px;
    cursor: pointer;
    background: url(${DetailPick});
`;

export const Blanket = styled.div`
    bottom: 0;
    left: 0;
    top: 0;
    right: 0;
    position: fixed;
    z-index: 1;
`;
